export default __webpack_public_path__ + "static/presentacion-automoviles-virtual-hotwheelsc-a9ce7d0a119e2a751f38ac63b2d40cf2.jpg";